<template>
    <error-message
            v-bind:message="message"
            v-bind:field-name="fieldName"
    >
    </error-message>
</template>

<script>
    import ErrorMessage from './ErrorMessage.vue';
    import ResourceMixin from '../../Util/Mixins/resources'

    export default {
        name: "min-length-error-message",
        mixins: [ResourceMixin],
        computed: {
            message(){
                const vm = this;

                //Min length of {1} exceeded.
                const baseMessage = vm.resource('Shared_Error_MinLength').replace('{1}', vm.minLength);

                return `${vm.fieldName}: ${baseMessage}`
            }
        },
        components: {ErrorMessage},
        props: {
            fieldName: {
                type: String,
                required: true
            },
            minLength: {
                type: Number,
                required: true
            }
        }
    }
</script>
